<template>
    <comp-9-prep-adherence :section="9" :page="16" :nextDisabled="nextDisabled" :next="nextScreen">
        <p class="caption font-weight-bold mb-1 input-label">
            Have you ever been prescribed PrEP?
        </p>
        <v-radio-group v-model="prepSelection" column>
            <v-radio v-for="choice in prepChoices" :key="choice.id" :label="choice.text" :value="choice"></v-radio>
        </v-radio-group>
        <v-text-field v-if="prepSelection && prepSelection.userEntered" outline single-line type="text" v-model.trim="prepSelectionResponse"></v-text-field>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            prepSelection: null,
            prepSelectionResponse: null
        };
    },
    computed: {
        prepResponse() {
            let selectedPrepResponse = find(this.prepChoices, 'selected');

            if (selectedPrepResponse) {
                return selectedPrepResponse;
            } else return null;
        },
        prepChoices: sync('section9/prepChoices'),
        nextScreen() {
            if (this.prepSelection) {
                return `/page/9/${this.prepSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            if (this.prepSelection && this.prepSelection.userEntered && !this.prepSelectionResponse) {
                return true;
            } else {
                return !this.prepSelection;
            }
        }
    },
    watch: {
        prepSelection(newPrepSelection) {
            forEach(this.prepChoices, o => {
                if (o.id === newPrepSelection.id) {
                    o.selected = true;
                    if (o.userEntered) {
                        o.response = this.prepSelectionResponse;
                    }
                } else {
                    o.selected = false;
                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        prepSelectionResponse(newPrepSelectionResponse) {
            forEach(this.prepChoices, o => {
                if (o.id === this.prepSelection.id && o.userEntered) {
                    o.response = newPrepSelectionResponse;
                } else if (o.userEntered) {
                    o.response = null;
                }
            });
        }
    },
    mounted() {
        this.prepSelection = this.prepResponse;
        if (this.prepSelection && this.prepSelection.userEntered && this.prepSelection.response) {
            this.prepSelectionResponse = this.prepSelection.response;
        }
    }
};
</script>
